import React, { useEffect, useRef, useState,useCallback } from "react";
import dayjs from "dayjs";
import "./dashboard.css";
import {
  hasUserAccess,
  getUserRole,
  getUserDetails,
} from "../../../../backend/auth";
import { USER_PRIVILEGES } from "../../UserManagement/Roles/RoleConfiguration";

import PageLoader from "../../../shared/PageLoader";
import { useHistory } from "raviger";
import Table, {
  CellTmpl,
  DEFAULT_PAYLOAD,
  TitleTmpl,
  reactFormatter,
} from "../common/Table";
import {
    useGetCompanyLicenses,
  } from "../../../../backend/license";
import {preventDefault} from "../../../../utils/common";
import LicenseFilters from "../common/LicenseFilters";
import LicenseFilterCards from "../common/LicenseFilterCards";
import AddNewLicensePanel from "./AddNewLicensePanel";
import LicenseDetail from "./LicenseDetail";
import { useSidenav } from "../../../../contexts/SidenavContext";

const SortFields: any = {
  "act.name": "actn_ame",
  "rule.name": "rule_name",
  "activity.name": "activity_name",
  "activity.type": "activity_activity_type",
  "associate_company.name": "associate_company_name",
  "location.name": "location_name",
};

function getAdvanceSearch(state: any) {
  const filters = [];
  if ((state || {}).fromDate) {
    filters.push({
      columnName: "fromDate",
      value: dayjs(state.fromDate).startOf("D").toISOString(),
    });
    filters.push({
      columnName: "toDate",
      value: dayjs(state.toDate).endOf("D").toISOString(),
    });
  }

  if ((state || {}).auditType) {
    filters.push({ columnName: "auditType", value: state.auditType });
  }
  return filters.length > 0 ? filters : undefined;
}

function buildRoleBasedFilters() {
  const user = getUserDetails();
  const role = getUserRole();
  const roleFilters: any = {};

  if (role === "License Owner") {
    roleFilters.assigned_to_user_id_eq = user.user_id;
  }
  return roleFilters;
}

function LicenseDashboard() {
  const { state }: any = useHistory();
  const { toggleSidenav } = useSidenav();
  const [checkedStatuses, setCheckedStatuses] = useState<any>(
    (state || {}).status ? { [state.status]: true } : {}
  );
  const [data, setData] = useState<any>();
  const [params, setParams] = useState<any>();
  const [locationFilters, setLocationFilter] = useState<any>();
  const lfRef: any = useRef();
  lfRef.current = locationFilters;
  const [advaceSearchFilters, setAdvanceSearchFilters] = useState(
    getAdvanceSearch(state)
  );
  const afRef: any = useRef();
  afRef.current = advaceSearchFilters;
  const [statusFilters, setStatusFilters] = useState<any>();
  const sfRef = useRef();
  sfRef.current = statusFilters;
  const [roleFilters, setRoleFilters] = useState<any>(buildRoleBasedFilters());
  const rfRef = useRef();
  rfRef.current = roleFilters;
  const [payload, setPayload] = useState<any>();
  const payloadRef = useRef();
  payloadRef.current = payload;
  const { licenses, total, isFetching, refetch, companyIds } = useGetCompanyLicenses(
    payload,
    Boolean(payload)
  );

  const [statsPayload, setStatsPayload] = useState<any>(null);
  const { licenses: allLicenses, refetch: refetchStats } = useGetCompanyLicenses(
    statsPayload,
    Boolean(statsPayload)
  );
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [previousFilters, setPreviousFilters] = useState<any>({});
  const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);
  const [isLicenseDetailOpen, setLicenseDetailOpen] = useState(false);
  const [selectedLicense, setSelectedLicense] = useState<any>(null);
  const [cardFilter, setCardFilter] = useState<string | null>(null);
  const [cardFilters, setCardFilters] = useState<any>({});
  const cfRef = useRef();
  cfRef.current = cardFilters;

  const onLocationChange = useCallback((filters: any) => {
    setLocationFilter(filters);

    const _params = {
      ...params,
      page: 1,
      filters: {
        ...(rfRef.current || {}),
        // ...filters,
        ...(sfRef.current || {}),
      },
    };
    setParams(_params);
    setPayload(_params);
    setPreviousFilters(filters);

    const _statsParams = {
      ...DEFAULT_PAYLOAD,
      include: [
        "company",
        "associate_company",
        "location",
        "license_type",
        "application_type",
        "assigned_to_user",
        // "escalation_user"
        "created_by"
      ],
      methods: ["watcher_names"],
      includes: [
        "company",
        "associate_company",
        "location",
        "license_type",
        "application_type",
        "assigned_to_user",
        // "escalation_user"
        "created_by"
      ],
      filters: {
        ...(rfRef.current || {}),
        ...filters,
      },
      per: 10000,
    };
    setStatsPayload(_statsParams);
  }, [params]);

  const handleCardFilterChange = useCallback((filterType: string | null) => {
    setCardFilter(filterType);

    const _cardFilters: any = {};

    if (filterType === 'active') {
      _cardFilters.status_eq = 'active';
    } else if (filterType === 'up_for_renewal') {
      _cardFilters.status_eq = 'up_for_renewal';
    } else if (filterType === 'perpetual') {
      _cardFilters.is_perpetual_eq = true;
    }

    setCardFilters(_cardFilters);

    const _params = {
      ...params,
      page: 1,
      filters: {
        ...(rfRef.current || {}),
        ...(lfRef.current || {}),
        ..._cardFilters,
      },
    };
    setParams(_params);
    setPayload(_params);

    const _statsParams = {
      ...DEFAULT_PAYLOAD,
      include: [
        "company",
        "associate_company",
        "location",
        "license_type",
        "application_type",
        "assigned_to_user",
        // "escalation_user"
      ],
      includes: [
        "company",
        "associate_company",
        "location",
        "license_type",
        "application_type",
        "assigned_to_user",
        // "escalation_user"
      ],
      filters: {
        ...(rfRef.current || {}),
        ...(lfRef.current || {}),
      },
      per: 10000,
    };
    setStatsPayload(_statsParams);
  }, [params]);

 useEffect(() => {
    const initialPayload = {
      ...DEFAULT_PAYLOAD,
      page: 1,
      per: 10,
      include: [
        "company",
        "associate_company",
        "location",
        "license_type",
        "application_type",
        "assigned_to_user",
        // "escalation_user"
        "created_by"
      ],
      methods: ["watcher_names"],
      includes: [
        "company",
        "associate_company",
        "location",
        "license_type",
        "application_type",
        "assigned_to_user",
        "created_by"
        // "escalation_user"
      ],
      filters: buildRoleBasedFilters(),
      // sorts: ["status asc", "expiry_date desc"]
    };
    setParams(initialPayload);
    setPayload(initialPayload);

    const initialStatsPayload = {
      ...DEFAULT_PAYLOAD,
      include: [
        "company",
        "associate_company",
        "location",
        "license_type",
        "application_type",
        "assigned_to_user",
        // "escalation_user"
        "created_by"
      ],
      methods: ["watcher_names"],
      includes: [
        "company",
        "associate_company",
        "location",
        "license_type",
        "application_type",
        "assigned_to_user",
        // "escalation_user"
        "created_by"
      ],
      filters: buildRoleBasedFilters(),
      per: 10000, 
    };
    setStatsPayload(initialStatsPayload);
  }, []);

  function StatusTmpl({ cell }: any) {
    const status = cell.getValue() || "";
    const statusLower = status.toLowerCase();

    let colorClass = "";

    if (statusLower.includes("active")) {
      colorClass = "active";
    } else if (statusLower.includes("expired")) {
      colorClass = "expired";
    } else if (statusLower.includes("renewal")) {
      colorClass = "renewal";
    } else if (statusLower.includes("surrendered")) {
      colorClass = "expired";
    }

    return (
      <span className={`text-capitalize color-class fw-bold ${colorClass}`}>
        {status.replace(/_/g, " ")}
      </span>
    );
  }

  function DateTmpl({ cell }: any) {
    const value = cell.getValue();
    return value ? dayjs(value).format("DD-MM-YYYY") : "-";
  }

  function ActionsTmpl({ cell }: any) {
    const row = cell.getData();
    return (
      <div className="d-flex gap-2">
        <button 
          className="btn btn-sm btn-icon"
          onClick={()=> {
            toggleSidenav(false);
            setSelectedLicense(row);
            setLicenseDetailOpen(true);
          }}
          title="View Details"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <path d="M0.666626 8.65627C0.666626 8.65627 3.33329 3.32294 7.99996 3.32294C12.6666 3.32294 15.3333 8.65627 15.3333 8.65627C15.3333 8.65627 12.6666 13.9896 7.99996 13.9896C3.33329 13.9896 0.666626 8.65627 0.666626 8.65627Z" stroke="#2965AD" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M7.99996 10.6563C9.10453 10.6563 9.99996 9.76084 9.99996 8.65627C9.99996 7.5517 9.10453 6.65627 7.99996 6.65627C6.89539 6.65627 5.99996 7.5517 5.99996 8.65627C5.99996 9.76084 6.89539 10.6563 7.99996 10.6563Z" stroke="#2965AD" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>
    );
  }

  function LocationTmpl({ cell }: any) {
    const row = cell.getData();
    return (
      <div className="d-flex gap-2">
        {row.location  ? `${row.location.name} - ${row.location.code}`  : "-"}
      </div>
    );
  }

  const columns = [
    {
      title: "IDs",
      field: "id",
      //width: 150,
      formatter: reactFormatter(<CellTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
      headerClick: (e: any, col: any) => {
        preventDefault(e);
      },
    },
    {
      title: "License Name",
      field: "license_name",
      formatter: reactFormatter(<CellTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
    },
    {
      title: "License Type",
      field: "license_type.name",
      formatter: reactFormatter(<CellTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
    },
    {
      title: "Expiry Date",
      field: "expiry_date",
      formatter: reactFormatter(<DateTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
    },
    {
      title: "Company",
      field: "company.name",
      formatter: reactFormatter(<CellTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
    },
    {
      title: "Associate Company",
      field: "associate_company.name",
      formatter: reactFormatter(<CellTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
    },
    {
      title: "Location",
      field: "license.location.name",
      formatter: reactFormatter(<LocationTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
    },
    {
      title: "Assigned To",
      field: "assigned_to_user.name",
      formatter: reactFormatter(<CellTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
    },
    {
      title: "Status",
      field: "status",
      formatter: reactFormatter(<StatusTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
      headerSort: false,
    },
    {
      title: "Actions",
      field: "actions",
      formatter: reactFormatter(<ActionsTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
      headerSort: false,
    },
  ];


  const [tableConfig] = useState({
    paginationMode: "remote",
    ajaxRequestFunc,
    columns,
    rowHeight: "auto",
    selectable: getUserRole() === "License Manager" ? true : false,
    paginate: true,
    // initialSort: ["month desc"],
    rowFormatter,
  });

  function rowFormatter(row: any) {
    const data = row.getData();
    const element = row.getElement();
  }

  function formatApiResponse(params: any, list: any, totalRecords: number) {
    const { page, per } = params || {};
    const tdata = {
      data: list,
      total: totalRecords,
      last_page: Math.ceil(totalRecords / (per || 1)) || 1,
      page: page || 1,
    };
    return tdata;
  }

  function hasFilters(ref: any, field = "company_id_eq") {
    const _filters: any =
      (ref
        ? ref.current
        : ({ ...(payloadRef.current || {}) } as any)["filters"]) || {};
    return _filters[field];
  }

  function ajaxRequestFunc(url: any, config: any, params: any) {
    const { field, dir } = (params.sort || [])[0] || {};
    const _params = {
      per: params.size,
      page: params.page,
      // sorts: [`${SortFields[field] || field || "month"} ${dir || "desc"}`],
      include: [
        "company",
        "associate_company",
        "location",
        "license_type",
        "application_type",
        "assigned_to_user",
        // "escalation_user"
        "created_by"
      ],
      methods: ["watcher_names"],
      includes: [
        "company",
        "associate_company",
        "location",
        "license_type",
        "application_type",
        "assigned_to_user",
        // "escalation_user"
        "created_by"
      ],
    };
    setParams(_params);
    setPayload({
      ...DEFAULT_PAYLOAD,
      ..._params,
      filters: {
        ...(rfRef.current || {}),
        ...(lfRef.current || {}),
        ...(afRef.current || {}),
        ...(sfRef.current || {}),
      },
    });
    return Promise.resolve(formatApiResponse(params, licenses || [], total || 0));
  }

  function handlePageNav(_pagination: any) {
    const _params = {
      ...params,
      ..._pagination,
      filters: {
        ...(rfRef.current || {}),
        ...(lfRef.current || {}),
        ...(afRef.current || {}),
        ...(sfRef.current || {}),
        ...(cfRef.current || {}),
      }
    };
    setParams({ ..._params });
    setPayload({ ..._params });
  }

  useEffect(() => {
    if (locationFilters !== undefined) {
      const _params = {
        ...params,
        page: 1,
        filters: {
          ...(rfRef.current || {}),
          ...(locationFilters || {}),
          ...(sfRef.current || {}),
        },
      };
      setParams(_params);
      setPayload(_params);
    }
  }, [locationFilters, statusFilters]);


  useEffect(() => {
    if (checkedStatuses) {
      const keys = Object.keys(checkedStatuses);
      const result = keys.filter((key) => !!checkedStatuses[key]);
      const _result: any = {};
      if (result.length > 0) {
        _result["status_in"] = result;
      }
      setStatusFilters(_result);
    }
  }, [checkedStatuses]);

  useEffect(() => {
    if (!isFetching && payload) {
      setSelectedRows([]);
      setData(formatApiResponse(params, licenses || [], total || 0));
    }
  }, [isFetching]);

  return (
    <>
      <div className="licensedashboard-wrapper">
        <div className="d-flex flex-column license-dashboard">
          <div className="d-flex p-3 align-items-center pageHeading">
            <div>
              <h4 className="mb-0">Licenses</h4>
              {(getUserRole() === "License Manager" || getUserRole() === "License Owner" ) ? <p>
                Track, manage, and oversee all licenses issued across companies, associate companies, and locations.
              </p> : <p>
                Check and oversee all licenses issued across companies, associate companies, and locations. 
              </p>}
            </div>
            <div className="d-flex align-items-end h-100">
              {hasUserAccess(USER_PRIVILEGES.CREATE_COMPANY_LICENSE) && (
                <button className="button-primary" onClick={() => {
                  toggleSidenav(false);
                  setIsSidePanelOpen(true);
                }}>Add New License</button>
              )}
            </div>
          </div>

          <form className="p-0 mx-3">
            <div className="card border-0 py-4 px-2 mb-3">
              <div className="d-flex flex-row filters">
                <LicenseFilters onChange={onLocationChange} />
              </div>
            </div>
            <LicenseFilterCards
              licenses={allLicenses || []}
              isLoading={isFetching}
              onFilterChange={handleCardFilterChange}
              activeFilter={cardFilter}
            />
          </form>
          <div className="position-relative p-3 pb-0 license-table">
            <Table
              data={data}
              options={tableConfig}
              isLoading={isFetching}
              onSelectionChange={setSelectedRows}
              onPageNav={handlePageNav}
            />
          </div>
        </div>
        {/* {(submitting) && <PageLoader />} */}
        <AddNewLicensePanel
          isOpen={isSidePanelOpen}
          closePanel={() => setIsSidePanelOpen(false)}
          onSuccess={() => {
            refetch();
            refetchStats();
          }}
        />
        <LicenseDetail
          isOpen={isLicenseDetailOpen}
          license={selectedLicense}
          closePanel={() => { setLicenseDetailOpen(false); setSelectedLicense(null); }}
          refetch={() => {
            refetch();
            refetchStats();
          }}
        />
      </div>
      {isFetching && <PageLoader />}
    </>
  );
}

export default LicenseDashboard;
